import { applicationContextState, setApplicationStateById } from '@/contexts/ApplicationContext/ApplicationContext';

export const updateApplicationContext =
  (setState: setApplicationStateById) => (updateObject: Partial<applicationContextState>) => {
    setState('UPDATE', (s) => {
      return {
        ...s,
        ...updateObject,
      };
    });
  };
